module.exports = __webpack_public_path__ + "media/images/display/success-40ffc8990185ef5ce2e1ffe9cfc190e8.svg";